import { render, staticRenderFns } from "./commonNotive.vue?vue&type=template&id=4a2f5e7d&scoped=true&"
import script from "./commonNotive.vue?vue&type=script&lang=js&"
export * from "./commonNotive.vue?vue&type=script&lang=js&"
import style0 from "./commonNotive.vue?vue&type=style&index=0&id=4a2f5e7d&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2f5e7d",
  null
  
)

export default component.exports